import type { CabAgendaItemStatus } from '../types/cabAgendaItem';

export const CAB_AGENDA_STATUS_OPTIONS: Array<{
  value: CabAgendaItemStatus;
  label: string;
}> = [
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'paused', label: 'Paused' },
  { value: 'complete', label: 'Complete' },
  { value: 'no_decision', label: 'No Decision' },
];

export const CAB_AGENDA_DEFAULT_STATUS: CabAgendaItemStatus = 'pending';
/** Fallback when no existing agenda items; create flow prefers max(order)+1. */
export const CAB_AGENDA_DEFAULT_ORDER = 1;
export const CAB_AGENDA_SHORT_DESCRIPTION_MAX = 1000;

/** Change Request states eligible for CAB agenda Task lookup. */
export const CAB_AGENDA_ELIGIBLE_CHANGE_STATES = ['new', 'assess', 'authorize'] as const;

export function getAgendaStatusLabel(status: string): string {
  return CAB_AGENDA_STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;
}
